import { basicService } from "@/services/basic.service";
import ACTIONCODE from '@/config/actionCode.env';
import TABLE_NAME from "@/config/table.env";
import OBJECT from '@/config/object.env'
const tableName = TABLE_NAME.DM_TCKH_CHITIEUTHUCHINGANSACH
const typeForm = 0;
const typeJson = 1;
const actions = {

    //Get Data
    async getPagingChitieuThuchiNgansach({ dispatch }, { params, type = 1 }) {
        if (type == 1) {
            params.ACTIONCODE = ACTIONCODE.SELECTACTIVEPAGING
        }
        else if (type == 2) {
            params.ACTIONCODE = ACTIONCODE.SELECTDELETEDPAGING
        }

        return await basicService.queryData(params, tableName).then(
            (resp) => {
                if (resp.statusCode == 200) {

                    return resp.data;
                }
                else {
                    dispatch("alert/warning", "Không tồn tại dữ liệu", { root: true });
                    return null;
                }
            },
            (error) => {
                console.log(error.message);
                dispatch("alert/error", "Có lỗi trong quá trình lấy dữ liệu", { root: true });
                return null;
            }
        );
    },

    async getsChitieuThuchiNgansach({ dispatch }, { params, type = 1 }) {
        if (type == 1) {
            params.ACTIONCODE = ACTIONCODE.SELECTACTIVE
        }
        else if (type == 2) {
            params.ACTIONCODE = ACTIONCODE.SELECTDELETED
        }

        return await basicService.queryData(params, tableName).then(
            (resp) => {
                if (resp.statusCode == 200) {

                    return resp.data;
                }
                else {
                    dispatch("alert/warning", "Không tồn tại dữ liệu", { root: true });
                    return null;
                }
            },
            (error) => {
                console.log(error.message);
                dispatch("alert/error", "Có lỗi trong quá trình lấy dữ liệu", { root: true });
                return null;
            }
        );
    },

    async getBasicChitieuThuchiNgansach({ dispatch }, { params }) {
        params.ACTIONCODE = ACTIONCODE.SELECTBASICLIST
        return await basicService.queryData(params, tableName).then(
            (resp) => {
                if (resp.statusCode == 200) {

                    return resp.data;
                }
                else {
                    dispatch("alert/warning", "Không tồn tại dữ liệu", { root: true });
                    return null;
                }
            },
            (error) => {
                console.log(error.message);
                dispatch("alert/error", "Có lỗi trong quá trình lấy dữ liệu", { root: true });
                return null;
            }
        );
    },

    async getDetailChitieuThuchiNgansach({ dispatch }, { params }) {
        params.ACTIONCODE = ACTIONCODE.SELECT1

        return await basicService.queryData(params, tableName).then(
            (resp) => {
                if (resp.statusCode == 200) {

                    return resp.data[0];
                }
                else {
                    dispatch("alert/warning", "Không tồn tại dữ liệu", { root: true });
                    return null;
                }
            },
            (error) => {
                console.log(error.message);
                dispatch("alert/error", "Có lỗi trong quá trình lấy dữ liệu", { root: true });
                return null;
            }
        );
    },

    // async checkExistChitieuThuchiNgansach({ dispatch }, { params }) {
    //     params.ACTIONCODE = ACTIONCODE.CHECKEXISTSNAME

    //     return await basicService.queryData(params, tableName).then(
    //         (resp) => {
    //             if (resp.statusCode == 200) {
    //                 return resp;
    //             }
    //             else {
    //                 //dispatch("alert/warning", "Không tồn tại dữ liệu", { root: true });
    //                 return null;
    //             }
    //         },
    //         (error) => {
    //             console.log(error.message);
    //             //dispatch("alert/error", "Có lỗi trong quá trình lấy dữ liệu", { root: true });
    //             return null;
    //         }
    //     );
    // },


    //Change Data
    // async createChitieuThuchiNgansach({ dispatch }, { model }) {
    //     model.ACTIONCODE = ACTIONCODE.INSERT1
    //     return await basicService.executeData(model, typeJson, tableName).then(
    //         (resp) => {
    //             if (resp.statusCode == 200) {
    //                 dispatch("alert/success", "Thêm mới dữ liệu thành công", { root: true });
    //                 //return resp;
    //                 return true;
    //             }
    //             else {
    //                 dispatch("alert/error", "Thêm thất bại: " + resp.message, { root: true });
    //                 //return resp;
    //                 return false;
    //             }
    //         },
    //         (error) => {
    //             console.log(error.message);
    //             dispatch("alert/error", "Thêm thất bại", { root: true });
    //             return false;
    //         }
    //     );
    // },

    // async updateChitieuThuchiNgansach({ dispatch }, { model }) {
    //     model.ACTIONCODE = ACTIONCODE.UPDATE1
    //     return await basicService.executeData(model, typeJson, tableName).then(
    //         (resp) => {
    //             if (resp.statusCode == 200) {
    //                 dispatch("alert/success", "Cập nhật dữ liệu thành công", { root: true });
    //                 return true;
    //             }
    //             else {
    //                 dispatch("alert/error", "Cập nhật thất bại: " + resp.message, { root: true });
    //                 return false;
    //             }
    //         },
    //         (error) => {
    //             console.log(error.message);
    //             dispatch("alert/error", "Cập nhật thất bại", { root: true });
    //             return false;
    //         }
    //     );
    // },

    // async deleteChitieuThuchiNgansach({ dispatch }, { model, type = 1 }) {
    //     if (type == 1) {
    //         model.ACTIONCODE = ACTIONCODE.DELFAKE1
    //     }
    //     else if (type == 2) {
    //         model.ACTIONCODE = ACTIONCODE.DELREAL1
    //     }
    //     return await basicService.executeData(model, typeJson, tableName).then(
    //         (resp) => {
    //             if (resp.statusCode == 200) {
    //                 dispatch("alert/success", "Xóa dữ liệu thành công", { root: true });
    //                 return true;
    //             }
    //             else {
    //                 dispatch("alert/error", "Xóa thất bại: " + resp.message, { root: true });
    //                 return false;
    //             }
    //         },
    //         (error) => {
    //             console.log(error.message);
    //             dispatch("alert/error", "Xóa thất bại", { root: true });
    //             return false;
    //         }
    //     );
    // },

    // async restoreChitieuThuchiNgansach({ dispatch }, { model }) {
    //     model.ACTIONCODE = ACTIONCODE.RESTORE1
    //     return await basicService.executeData(model, typeJson, tableName).then(
    //         (resp) => {
    //             if (resp.statusCode == 200) {
    //                 dispatch("alert/success", "Khôi phục dữ liệu thành công", { root: true });
    //                 return true;
    //             }
    //             else {
    //                 dispatch("alert/error", "Khôi phục thất bại: " + resp.message, { root: true });
    //                 return false;
    //             }
    //         },
    //         (error) => {
    //             console.log(error.message);
    //             dispatch("alert/error", "Khôi phục thất bại", { root: true });
    //             return false;
    //         }
    //     );
    // },

    // async handleListChitieuThuchiNgansach({ dispatch }, { model, type }) {
    //     if (type) {
    //         if (type == OBJECT.NAVIGATECODE_VALUE.DELETE_TEMP) {
    //             model.ACTIONCODE = ACTIONCODE.DELFAKELIST
    //         }
    //         else if (type == OBJECT.NAVIGATECODE_VALUE.DELETE) {
    //             model.ACTIONCODE = ACTIONCODE.DELREALLIST
    //         }
    //         else if (type == OBJECT.NAVIGATECODE_VALUE.RESTORE) {
    //             model.ACTIONCODE = ACTIONCODE.RESTORELIST
    //         }
    //         else if (type == OBJECT.NAVIGATECODE_VALUE.OFF_ENABLED || type == OBJECT.NAVIGATECODE_VALUE.ON_ENABLED) {
    //             model.ACTIONCODE = ACTIONCODE.SETENABLED
    //         }

    //         return await basicService.executeData(model, typeJson, tableName).then(
    //             (resp) => {
    //                 if (resp.statusCode == 200) {
    //                     if (type == 1) dispatch("alert/success", "Xóa dữ liệu thành công", { root: true });
    //                     if (type == 2) dispatch("alert/success", "Xóa hoàn toàn dữ liệu thành công", { root: true });
    //                     if (type == 3) dispatch("alert/success", "Khôi phục dữ liệu thành công", { root: true });
    //                     if (type == 4) dispatch("alert/success", "Thay đổi hiển thị trên cổng thành công", { root: true });
    //                     return true;
    //                 }
    //                 else {
    //                     if (type == 1) dispatch("alert/error", "Xóa thất bại: " + resp.message, { root: true });
    //                     if (type == 2) dispatch("alert/error", "Xóa hoàn toàn thất bại: " + resp.message, { root: true });
    //                     if (type == 3) dispatch("alert/error", "Khôi phục thất bại: " + resp.message, { root: true });
    //                     if (type == 4) dispatch("alert/error", "Thay đổi hiển thị trên cổng thất bại: " + resp.message, { root: true });
    //                     return false;
    //                 }
    //             },
    //             (error) => {
    //                 console.log(error.message);
    //                 dispatch("alert/error", "Xóa thất bại", { root: true });
    //                 return false;
    //             }
    //         );

    //     }
    // },

    // async setEnabledChitieuThuchiNgansach({ dispatch }, { model }) {
    //     model.ACTIONCODE = ACTIONCODE.SETENABLED
    //     return await basicService.executeData(model, typeJson, tableName).then(
    //         (resp) => {
    //             if (resp.statusCode == 200) {
    //                 dispatch("alert/success", "Cập nhật hiển thị trên cổng thành công", { root: true });
    //                 return true;
    //             }
    //             else {
    //                 dispatch("alert/error", "Cập nhật hiển thị trên cổng thất bại: " + resp.message, { root: true });
    //                 return false;
    //             }
    //         },
    //         (error) => {
    //             console.log(error.message);
    //             dispatch("alert/error", "Xóa thất bại", { root: true });
    //             return false;
    //         }
    //     );
    // },



    //Customs
};


export const chitieuThuchiNgansach = {
    namespaced: true,
    actions,
};
